import { jsxs as o, Fragment as m, jsx as l } from "react/jsx-runtime";
import { b as p } from "../../base-nYmjnkiN.js";
import { useMemo as h } from "react";
import { useIsInternalForApp as u } from "../../core/hooks/useIsInternalForApp.js";
import { cssX as r } from "../../core/utils/css.js";
import { c as t } from "../../index-C7ezJk5b.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import { Link as _ } from "react-router-dom";
const N = ({
  data: e,
  testId: i
}) => {
  const a = u(e.internalForApp), { globalSearch: s } = p(), c = h(
    () => {
      const n = e.icon;
      return {
        "data-testid": i,
        className: t(r("GlobalSearchResultCategory__item")),
        onClick: () => {
          s.setIsOpened(!1);
        },
        children: /* @__PURE__ */ o(m, { children: [
          !!n && /* @__PURE__ */ l("div", { className: t(r("GlobalSearchResultCategory__item-icon")), children: /* @__PURE__ */ l(n, {}) }),
          /* @__PURE__ */ o("div", { className: t(r("GlobalSearchResultCategory__item-text")), children: [
            /* @__PURE__ */ l("div", { className: t(r("GlobalSearchResultCategory__item-title")), children: /* @__PURE__ */ o("div", { className: t(r("GlobalSearchResultCategory__item-title-inner")), children: [
              e.title,
              !!e.subTitle && /* @__PURE__ */ o("div", { className: t(r("GlobalSearchResultCategory__item-sub-title")), children: [
                " ",
                e.subTitle
              ] })
            ] }) }),
            !!e.description && /* @__PURE__ */ l("div", { className: t(r("GlobalSearchResultCategory__item-description")), children: e.description })
          ] })
        ] })
      };
    },
    [e, i, s]
  );
  return a ? /* @__PURE__ */ l(_, { to: e.path, ...c }) : /* @__PURE__ */ l("a", { href: e.url, ...c });
};
export {
  N as default
};
